import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Accordion, Grid, Icon } from 'semantic-ui-react';
import { CurrencyNumberPropType } from '../../../../../../../services/proptypes';
import { formatCurrency } from '../../../../../../../utils/currency';
import { FeePropType } from '../../../../CartSummary.propTypes';
import './FeesBreakdown.css';
var defaultProps = {
  total: '0.00',
  details: []
};
function FeesBreakdown(_ref) {
  var label = _ref.label,
    total = _ref.total,
    details = _ref.details;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFees = _useState2[0],
    setShowFees = _useState2[1];
  function onClick() {
    setShowFees(function (previousState) {
      return !previousState;
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, total > 0 && /*#__PURE__*/React.createElement(Accordion, {
    className: "fees-breakdown-accordion"
  }, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: showFees,
    className: "title",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "left"
  }, label, /*#__PURE__*/React.createElement(Icon, {
    name: "dropdown"
  })), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "right",
    textAlign: "right"
  }, formatCurrency(total))), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: showFees
  }, /*#__PURE__*/React.createElement(Grid, null, details.map(function (fee) {
    return /*#__PURE__*/React.createElement(Grid.Row, {
      className: "breakdown-row",
      key: fee.label
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      width: 8,
      floated: "left"
    }, fee.label), /*#__PURE__*/React.createElement(Grid.Column, {
      width: 8,
      floated: "right",
      textAlign: "right",
      className: "fee-value"
    }, formatCurrency(fee.value)));
  })))));
}
FeesBreakdown.defaultProps = defaultProps;
export default FeesBreakdown;